import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { ProcessoCliente } from '../../comum/modelos/processo-cliente';
import { ProcessoSetor } from '../../comum/modelos/processo-setor';
import { SetorCliente } from '../../comum/modelos/setor-cliente';
import { SetorService } from '../../setor/setor.service';
import { ProcessoService } from '../processo.service';
import { SetorPontoFisico } from '../../comum/modelos/setor-ponto-fisico';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
    selector: 'app-listar-processos-cliente',
    templateUrl: './listar-processos-cliente.component.html',
    styleUrls: ['./listar-processos-cliente.component.css']
})
export class ListarProcessosClienteComponent implements OnInit {

    @Output() processoSetorEvent: EventEmitter<ProcessoSetor[]>;
    @Input() setoresCliente: SetorCliente[];

    filtroPesquisaNomeProcesso: string;
    processosCliente: ProcessoCliente[];
    processosClienteSelecionados: ProcessoCliente[];
    setoresPontoFisico: SetorPontoFisico[];
    processosSetor: ProcessoSetor[];
    paginacao: Paginacao;
    evento: Evento;
    selecionados: boolean;

    public loading = false;

    constructor(private _processoService: ProcessoService,
        private _comumService: ComumService,
        private _setorService: SetorService,
        private _cookieService: CookieService,
        private _authService: AuthService) {
        this.paginacao = new Paginacao();
        this.evento = this._comumService.evento;
        this.processosCliente = new Array<ProcessoCliente>();
        this.processosClienteSelecionados = new Array<ProcessoCliente>();
        this.setoresPontoFisico = new Array<SetorPontoFisico>();
        this.processoSetorEvent = new EventEmitter<ProcessoSetor[]>();
        if (this.evento !== undefined) {
            setTimeout(() => {
                this._comumService.cleanEvent();
            }, 2000);
        }
    }

    ngOnInit() {
        this.paginacao.itens = 5;
        this.paginacao.page = 1;
        this.loading = true;
        const self = this;

        this._processoService.obterProcessosClienteHttp(parseInt(this._cookieService.get('idCliente')))
            .subscribe((processosCliente) => {
                self._processoService.obterProcessosSetoresClienteHttp(this.setoresCliente)
                    .subscribe((processosSetor: ProcessoSetor[]) => {
                        self.processosSetor = processosSetor;
                        for (const processoCliente of processosCliente) {
                            for (const processoSetor of processosSetor) {
                                if (processoCliente.idProcessoCliente === processoSetor.idProcessoCliente) {
                                    processoCliente.selecionado = true;
                                    break;
                                }
                            }
                            self.processosCliente.push(processoCliente);
                            self.loading = false;
                        }
                    });
            });
    }

    pesquisarPorFiltro(filtro: any): void {
        this.filtroPesquisaNomeProcesso = filtro.value;
    }

    selecionar(processoCliente: ProcessoCliente): void {
        processoCliente.selecionado = !processoCliente.selecionado;
        if (processoCliente.selecionado) {
            this.processosClienteSelecionados.push(processoCliente);
        } else {
            const index = this.processosClienteSelecionados.indexOf(processoCliente);
            this.processosClienteSelecionados.splice(index, 1);
        }
        processoCliente.alterado = true;
    }

    selecionarTodos(): void {
        this.selecionados = !this.selecionados;
        if (!this.selecionados) {
            this.processosClienteSelecionados = new Array<ProcessoCliente>();
        }

        this.processosCliente.forEach(processoCliente => {
            if (this.selecionados) {
                this.processosClienteSelecionados.push(processoCliente);
            }
            processoCliente.selecionado = this.selecionados;
            processoCliente.alterado = true;
        });
    }

    emit(): void {
        const processosSelecionados: ProcessoSetor[] = new Array<ProcessoSetor>();
        this._setorService.obterSetoresPontoFisicoSetoresClienteHttp(this.setoresCliente)
            .subscribe((setoresPontoFisico: SetorPontoFisico[]) => {
                this.setoresPontoFisico = setoresPontoFisico;
                for (const processoCliente of this.processosCliente) {
                    if (processoCliente.selecionado) {
                        for (const setorPontoFisico of this.setoresPontoFisico) {
                            const novoProcessoSetor = new ProcessoSetor();
                            novoProcessoSetor.idProcessoCliente = processoCliente.idProcessoCliente;
                            novoProcessoSetor.setorPontoFisico.idSetorPontoFisico = setorPontoFisico.idSetorPontoFisico;
                            novoProcessoSetor.selecionado = true;
                            novoProcessoSetor.alterado = true;
                            for (const processoSetor of this.processosSetor) {
                                if (processoSetor.idProcessoCliente === processoCliente.idProcessoCliente
                                    && processoSetor.setorPontoFisico.idSetorPontoFisico === setorPontoFisico.idSetorPontoFisico) {
                                    novoProcessoSetor.alterado = false;
                                    break;
                                }
                            }
                            if (novoProcessoSetor.alterado) {
                                processosSelecionados.push(novoProcessoSetor);
                            }
                        }
                    } else if (!processoCliente.selecionado && processoCliente.alterado) {
                        for (const processoSetor of this.processosSetor) {
                            if (processoSetor.idProcessoCliente === processoCliente.idProcessoCliente) {
                                processoSetor.selecionado = false;
                                processoSetor.alterado = true;
                                processosSelecionados.push(processoSetor);
                            }
                        }
                    }
                }
                this.processoSetorEvent.emit();
            });
    }
}




// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/processo/listar-processos-cliente/listar-processos-cliente.component.ts